import React from "react";
import CapacityWarning from "./CapacityWarning";
import PeriodWarning from "./PeriodWarning";
import { ButtonCancel, ModalWarn } from "./ModalWarning.styled";

export default function ModalWarning({
  show,
  isCancel,
  error,
  meterings,
  connectName,
  periodStart,
  periodEnd,
}) {
  return (
    <ModalWarn
      visible={show}
      onCancel={isCancel}
      closable={false}
      maskClosable={false}
      centered
      footer={[
        <ButtonCancel key="submit" onClick={isCancel}>
          Закрыть
        </ButtonCancel>,
      ]}
    >
      {error === "100220" ? (
        <PeriodWarning
          connectName={connectName}
          periodStart={periodStart}
          periodEnd={periodEnd}
        />
      ) : error ? (
        <CapacityWarning
          connectName={connectName}
          meterings={meterings}
          error={error}
        />
      ) : null}
    </ModalWarn>
  );
}
